import { EntityState } from '@ngrx/entity';

export class UsersForCampaign {
  campaignId: object;
}

export interface UsersForCampaignState extends EntityState<UsersForCampaign> { }
